import {
  SET_BREADCRUMBS,
  SET_IS_GENERATED,
  SET_IS_GENERATING,
  SET_SIDEBAR_COLLAPSED,
  SET_SELECTED_COUNTRY,
  SET_SELECTED_PRODUCT,
  SET_SELECTED_LANGUAGE,
} from "./actionTypes";

const initialState = {
  breadcrumbs: null,
  isGenerated: false,
  isGenerating: false,
  sidebarCollapsed: false,
  selectedCountry: "",
  selectedProduct: "",
  selectedLanguage: "en",
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BREADCRUMBS:
      return { ...state, breadcrumbs: action.payload };
    case SET_IS_GENERATED:
      return { ...state, isGenerated: action.payload };
    case SET_IS_GENERATING:
      return { ...state, isGenerating: action.payload };
    case SET_SIDEBAR_COLLAPSED:
      return { ...state, sidebarCollapsed: action.payload };
    case SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: action.payload };
    case SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.payload };
    case SET_SELECTED_LANGUAGE:
      return { ...state, selectedLanguage: action.payload };
    default:
      return state;
  }
};

export default appReducer;
